<template>
    <router-view></router-view>
</template>

<script>
import App from './application.js'

export default {
    name: 'App',

    components: {

    },

    data: function () {
        return {
            App: App
        }
    },
    watch: {

    },
    mounted: function () {
    }
}
</script>

<style>
</style>
